import { render, staticRenderFns } from "./TipoAditivoList.vue?vue&type=template&id=0b79ddea"
import script from "./TipoAditivoList.vue?vue&type=script&lang=js"
export * from "./TipoAditivoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports